import React, { useContext } from "react";
import { observer } from "mobx-react";

import { ResultsMenuStoreContext } from "@state/context/results";
import {
	SelectedTournamentsHeaderButton,
	ResultsTablesRenderer,
	DayTabs,
	ResultsSearchBar,
	ResultsSearchPhraseInfo,
} from "./components";

export default observer(function ResultContent() {
	const { selectedTournaments } = useContext(ResultsMenuStoreContext);

	return (
		<>
			<ResultsSearchBar />
			<ResultsSearchPhraseInfo />

			<DayTabs />

			<ResultsTablesRenderer>
				{selectedTournaments.length !== 0 && (
					<SelectedTournamentsHeaderButton />
				)}
			</ResultsTablesRenderer>
		</>
	);
});
